import { useCallback } from "react";
import { VariaveisAmbiente } from "../../../../config";
import { ETypeDomain } from "../../../../config/types";
import { RelatorioMensalReceitaB2Model } from "../../../../views/pages/private/relatorios/models/relatorio-models";
import { useApiBase } from "../../base/api-base";

export function useGerarRelatorioRMNRB2() {
  const { invocarApi, carregando, ...outrasPropriedades } = useApiBase();

  const gerarRelatorioRMNRB2 = useCallback(
    (filtros: RelatorioMensalReceitaB2Model) => {
      return invocarApi({
        url: `Relatorio/relatorio-rmnrb2`,
        method: "POST",
        enviarTokenUsuario: true,
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify(filtros),
        baseURL: VariaveisAmbiente.apiUrl,
        typeDomain: ETypeDomain.TouchPharma,
        apiVersion: 'v1'
      });
    },
    [invocarApi]
  );
  return {
    ...outrasPropriedades,
    carregando,
    gerarRelatorioRMNRB2,
  };

}